import { Drawer as MUIDrawer } from '@mui/material'
import { type CSSObject } from '@mui/material/styles'
import { styled } from '../../utils/styled'
import Grid from '../Grid'

export const StyledFlyout = styled(MUIDrawer)(
  ({ theme }): CSSObject => ({
    '.MuiPaper-root.MuiDrawer-paper': {
      overflowY: 'auto',
      backgroundColor: theme.tokens.background.main.default,
      backgroundImage: 'none',
      color: theme.tokens.foreground.main.primary,
      border: `1px solid ${theme.tokens.border.main.tonal}`,
      borderTopLeftRadius: theme.borderRadius.xxLarge,
      borderBottomLeftRadius: theme.borderRadius.xxLarge,
      boxShadow: theme.elevation.largeDepth,
      padding: theme.spacing(5),
      paddingBottom: theme.spacing(3),
      width: '400px',
      zIndex: theme.zIndex.flyout
    }
  })
)

export const StyledGridTopButtonsContainer = styled(Grid)(
  ({ theme }): CSSObject => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(4)
  })
)

export const StyledAvatarContainer = styled(Grid)(
  ({ theme }): CSSObject => ({
    textAlign: 'center',
    paddingBottom: '6px',
    '>div': {
      backgroundColor: theme.tokens.dataViz.primary[2].border.subtle,
      margin: '0 auto',
      marginTop: '20px',
      p: {
        color: theme.tokens.foreground.main.staticWhite,
        fontSize: theme.typography.h3.fontSize,
        fontWeight: theme.typography.h3.fontWeight
      }
    },
    h2: {
      marginTop: '25px',
      marginBottom: '3px'
    },
    button: {
      display: 'inline-flex',
      marginBottom: '6px',
      marginTop: '16px',
      width: '100%'
    }
  })
)
